import React, { useEffect, useState } from 'react';
import '../styles/Toast.css';

export interface ToastMessage {
    id: string;
    message: string;
    type: 'success' | 'error' | 'info';
    duration?: number;
}

interface ToastProps extends ToastMessage {
    onClose: (id: string) => void;
}

export const Toast: React.FC<ToastProps> = ({ id, message, type, duration = 3000, onClose }) => {
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsExiting(true);
            setTimeout(() => onClose(id), 300); // Wait for animation
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, id, onClose]);

    return (
        <div className={`toast ${type} ${isExiting ? 'exiting' : ''}`}>
            <span className="toast-message">{message}</span>
            <button className="toast-close" onClick={() => { setIsExiting(true); setTimeout(() => onClose(id), 300); }}>×</button>
        </div>
    );
};
